<template>
  <div class="p-2">
    <suggestion-drag-list :item-list="icon_list" :clone="cloneItem" style="display: flex; flex-wrap: wrap; justify-content: center;">
      <div
        class="action-draggable card mr-2 mb-2 text-center p-1"
        v-for="icon in icon_list"
        :key="icon.path"
        style="width: unset">
        <img width="64" :src="icon.icon" class="d-block mx-auto" />
        {{icon.name}}
      </div>

      <h4>Reward</h4>
      <div class="action-draggable card mr-2 mb-2 text-center p-1">
        <h6>Watch YouTube Video: 1h 43min</h6>
        <iframe
          width="320"
          height="200"
          src="https://www.youtube.com/embed/t7Yst8l51GY"
          frameborder="0"
          allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
      </div>

      <div class="action-draggable card mr-2 mb-2 text-center p-1">
        <h6>Watch YouTube Video: 31min</h6>
        <iframe
          width="320"
          height="200"
          src="https://www.youtube.com/embed/lLYwz3JUsLw"
          frameborder="0"
          allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
      </div>

      <!-- https://www.youtube.com/watch?v=nh-JUsmAiQI -->
    </suggestion-drag-list>
  </div>
</template>

<script>
import SuggestionDragList from '../SuggestionDragList'

// TODO: Block Video until user finished tasks before video
// TODO: Show picture here, embed video later

export default {
  props: {},
  data: () => ({
    icon_list: [],
  }),
  mounted() {
  },
  methods: {
    cloneItem( item ) {
      return { // call "make_task"
        type: "INLINE_TASK",
        title: item.name,
        no_drag: false,
        just_dropped: true,
        config: {
          pack: 'startups',
          icon: item.icon,
          tscColor: 'black'
        },
        component: "flow-quick-session",
      };
    },
  },
  components: {
    SuggestionDragList
  }
};
</script>
